/** 首页曝光：pageId */
export const TP_HOME_PAGE_ID = 'finance_loan_home';

/** 金融卡片曝光：moduleID */
export const TP_HOME_FINANCE_CARD_EXPOSE = 'finance_loan_home_financeCard';

/** 点击“去授信”(“申请额度”、“立即升级”)：moduleID */
export const TP_HOME_GO_CREDIT_CLICK = 'finance_loan_home_goCredit';

/** 点击“去提现”：moduleID */
export const TP_HOME_GO_APPLY_CLICK = 'finance_loan_home_goApply';

/** 认识臻有钱：moduleID */
export const TP_HOME_KNOW_US_CLICK = 'finance_loan_home_knowUs';

/** 如何授信：moduleID */
export const TP_HOME_GUIDE_CREDIT_CLICK = 'finance_loan_home_guideCredit';

/** 如何提现：moduleID */
export const TP_HOME_GUIDE_APPLY_CLICK = 'finance_loan_home_guideApply';

/** 优势列表曝光：moduleID */
export const TP_HOME_ADVANTAGE_LIST_EXPOSE = 'finance_loan_home_advantageList';

/** 身份证即将过期提醒bar */
export const TP_IDENTITY_EXPIRES_BAR = 'finance_loan_identity_expires';

/** 金融卡片内部-banner卡片 */
export const TP_HOME_FINANCE_CARD_ADV_BANNER = 'finance_loan_finance_card_adv_banner';

/** 点击“去授信”(“申请额度”、“立即升级”)被临额申请拦截：moduleID */
export const TP_HOME_GO_CREDIT_BLOCK_BY_TEMP_AMOUNT = 'finance_loan_home_goCreditBlockByTempAmount';

/** 金融卡片内部-优惠券信息 */
export const TP_HOME_FINANCE_CARD_COUPON_INFO = 'finance_loan_finance_card_coupon_info';

/** 消息通知栏曝光 */
export const TP_HOME_MESSAGE_NOTICE_BAR_EXPOSE = 'finance_loan_home_messageNoticeBar';

/** 消息通知栏点击关闭 */
export const TP_HOME_MESSAGE_NOTICE_BAR_CLOSE = 'finance_loan_home_messageNoticeBarClose';

/** 零用钱卡片曝光/点击 */
export const TP_HOME_POCKET_MONEY_CARD = 'finance_loan_home_pocketMoneyCard';

/** ”首页额度更新“弹窗-"确认"按钮：button */
export const TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CONFIRM = 'finance_loan_creditAmountAlterPopup_confirm';

/** ”首页额度更新“弹窗-"关闭"按钮：button */
export const TP_HOME_CREDIT_AMOUNT_ALTER_POPUP_CLOSE = 'finance_loan_creditAmountAlterPopup_close';

/** ”首页额度更新“弹窗：module */
export const TP_HOME_CREDIT_AMOUNT_ALTER_POPUP = 'finance_loan_creditAmountAlterPopup';

/** ”首页还款逾期提醒“弹窗：module */
export const TP_HOME_REPAY_OVERDUE_POPUP = 'finance_loan_home_overduePopup';

/** ”首页还款逾期提醒“弹窗-"去还款"按钮：button */
export const TP_HOME_REPAY_OVERDUE_POPUP_REPAY = 'finance_loan_home_overduePopup_repay';

/** ”首页还款逾期提醒“弹窗-"关闭"按钮：button */
export const TP_HOME_REPAY_OVERDUE_POPUP_CANCEL = 'finance_loan_home_overduePopup_cancel';
